import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-surface border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl text-white">
                Cafe <span className="text-saffron italic">Irani</span>
              </span>
            </Link>
            <p className="font-body text-white/50 text-sm leading-relaxed mb-6">
              Authentic Iranian cuisine in a modern setting. Experience the rich flavors and warm hospitality of Iran.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/50 hover:text-saffron hover:border-saffron/50 transition-all"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/50 hover:text-saffron hover:border-saffron/50 transition-all"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Menu", path: "/menu" },
                { label: "Reservations", path: "/reservations" },
                { label: "Gallery", path: "/gallery" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="font-body text-white/50 text-sm hover:text-saffron transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-white text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-saffron mt-0.5 flex-shrink-0" />
                <span className="font-body text-white/50 text-sm">
                  7854 Michael's Rd<br />
                  Beverly Hills, CA
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-saffron flex-shrink-0" />
                <a href="tel:+1234567890" className="font-body text-white/50 text-sm hover:text-saffron transition-colors">
                  +1 (234) 567-890
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-saffron flex-shrink-0" />
                <a href="mailto:Operations@virtuosogenai.com" className="font-body text-white/50 text-sm hover:text-saffron transition-colors">
                  Operations@virtuosogenai.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-heading text-white text-lg mb-6">Hours</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-saffron mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-body text-white/70 text-sm">Mon - Fri</p>
                  <p className="font-body text-white/50 text-sm">9:00 AM - 10:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-white/30 text-sm">
            © 2024 Cafe Irani. All rights reserved.
          </p>
          <p className="font-body text-white/30 text-sm">
            <a href="https://cafeirani.com" className="hover:text-saffron transition-colors">
              cafeirani.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
